import BaseEvent from './BaseEvent';
class StandardEvent extends BaseEvent {
}
export default StandardEvent;
//# sourceMappingURL=StandardEvent.js.map